//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoAutocompleteBasic from './demos/DemoAutocompleteBasic.vue'
import DemoAutocompleteDense from './demos/DemoAutocompleteDense.vue'
import DemoAutocompleteVariant from './demos/DemoAutocompleteVariant.vue'
import DemoAutocompleteMultiple from './demos/DemoAutocompleteMultiple.vue'
import DemoAutocompleteClearable from './demos/DemoAutocompleteClearable.vue'
import DemoAutocompleteChips from './demos/DemoAutocompleteChips.vue'
import DemoAutocompleteAutoSelectFirst from './demos/DemoAutocompleteAutoSelectFirst.vue'
import DemoAutocompleteFilter from './demos/DemoAutocompleteFilter.vue'
import DemoAutocompleteItemAndSelection from './demos/DemoAutocompleteItemAndSelection.vue'
import DemoAutocompleteAsynchronousItems from './demos/DemoAutocompleteAsynchronousItems.vue'
import DemoAutocompleteValidation from './demos/DemoAutocompleteValidation.vue'
import DemoAutocompleteValidateOnBlur from './demos/DemoAutocompleteValidateOnBlur.vue'
import DemoAutocompletePrefixAndSuffix from './demos/DemoAutocompletePrefixAndSuffix.vue'

// code
import {
  autocompleteBasic,
  autocompleteDense,
  autocompleteVariant,
  autocompleteMultiple,
  autocompleteClearable,
  autocompleteChips,
  autocompleteAutoSelectFirst,
  autocompleteFilter,
  autocompleteItemAndSelection,
  autocompleteAsynchronousItems,
  autocompleteValidation,
  autocompleteValidateOnBlur,
  autocompletePrefixAndSuffix,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoAutocompleteBasic,
    DemoAutocompleteDense,
    DemoAutocompleteVariant,
    DemoAutocompleteMultiple,
    DemoAutocompleteClearable,
    DemoAutocompleteChips,
    DemoAutocompleteAutoSelectFirst,
    DemoAutocompleteFilter,
    DemoAutocompleteItemAndSelection,
    DemoAutocompleteAsynchronousItems,
    DemoAutocompleteValidation,
    DemoAutocompleteValidateOnBlur,
    DemoAutocompletePrefixAndSuffix,
  },
  setup() {
    return {
      codeSnippets: {
        autocompleteBasic,
        autocompleteDense,
        autocompleteVariant,
        autocompleteMultiple,
        autocompleteClearable,
        autocompleteChips,
        autocompleteAutoSelectFirst,
        autocompleteFilter,
        autocompleteItemAndSelection,
        autocompleteAsynchronousItems,
        autocompleteValidation,
        autocompleteValidateOnBlur,
        autocompletePrefixAndSuffix,
      },
    }
  },
}
